module.exports = __webpack_public_path__ + "img/project2_medium@2x.25caea9c.webp";